module.exports = __webpack_public_path__ + "static/media/icon-upload.9639aaf6.svg";